export default __webpack_public_path__ + "static/media/LO15.9754e50f.mp3";